import {AdminRoleExampleConfig} from './admin-role-example/AdminRoleExampleConfig';
import {StaffRoleExampleConfig} from './staff-role-example/StaffRoleExampleConfig';
import {GuestRoleExampleConfig} from './only-guest-role-example/GuestRoleExampleConfig';

export const authRoleExamplesConfigs = [
    AdminRoleExampleConfig,
    StaffRoleExampleConfig,
    GuestRoleExampleConfig
];
